// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
//  <h4>Tasks</h4>
//  <div data-controller="nested-form">
//    <template data-target="nested-form.template">
//      <%= form.fields_for :tasks, Task.new, child_index: 'NEW_RECORD' do |task| %>
//        <%= render "task_fields", form: task %>
//      <% end %>
//    </template>
//
//    <%= form.fields_for :tasks do |task| %>
//      <%= render "task_fields", form: task %>
//    <% end %>
//
//    <div class="mb-3" data-target="nested-form.links">
//      <%= link_to "Add Task", "#", class: "btn btn-outline-primary", data: { action: "click->nested-form#add_association" } %>
//    </div>
//  </div>
//
//  # _task_fields.html.erb
//  <%= content_tag :div, class: "nested-fields", data: { new_record: form.object.new_record? } do %>
//    <div class="form-group">
//      <%= form.label :description %>
//      <%= form.text_field :description, class: 'form-control' %>
//      <small><%= link_to "Remove", "#", data: { action: "click->nested-form#remove_association" } %></small>
//    </div>
//
//    <%= form.hidden_field :_destroy %>
//  <% end %>

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["template", "links"];

  connect() {
    console.log("Nested form controller connected");
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields";
    this.adding = false;
  }

  add_association(event) {
    event.preventDefault();
    event.stopPropagation();

    // Get the button that was clicked
    const button = event.target.closest('a[data-action*="add_association"]');

    // Prevent double-clicking - check flag AND button state
    if (this.adding || (button && button.disabled)) {
      console.log("Already adding, ignoring click");
      return;
    }

    // Set flag and disable button immediately
    this.adding = true;
    if (button) {
      button.disabled = true;
      button.style.opacity = "0.6";
    }

    console.log("Adding association...");

    // Generate unique timestamp for this new record
    const timestamp = new Date().getTime();

    // Get template content and replace NEW_RECORD with timestamp
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      timestamp
    );

    // Insert the new content before the links section
    this.linksTarget.insertAdjacentHTML("beforebegin", content);

    console.log("Association added successfully");

    // Reset the flag and re-enable button after a delay
    setTimeout(() => {
      this.adding = false;
      if (button) {
        button.disabled = false;
        button.style.opacity = "1";
      }
      console.log("Ready for next addition");
    }, 500);
  }

  remove_association(event) {
    event.preventDefault();
    event.stopPropagation();

    console.log("Removing association...");

    const wrapper = event.target.closest(".nested-fields");
    if (!wrapper) {
      console.error("Could not find nested-fields wrapper");
      return;
    }

    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();
    } else {
      const destroyField = wrapper.querySelector("input[name*='_destroy']");
      if (destroyField) {
        destroyField.value = 1;
        wrapper.style.display = "none";
      }
    }

    console.log("Association removed successfully");
  }
}
